var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"px-6 text-none text-body-1 font-weight-medium rounded-lg mt-4",attrs:{"x-large":"","color":"error","elevation":"0","block":""},on:{"click":_vm.initHubspotChat}},[_c('v-icon',{attrs:{"left":""},domProps:{"textContent":_vm._s('ph-fill ph-warning')}}),_vm._v(" "+_vm._s(_vm.$t("action.reportError"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }